import HTTP from "../../http";

const ORDERS_ENDPOINT = "/orders";
const USER_ORDERS_ENDPOINT = "/user/";

export async function getOrdersForUser() {
  return await HTTP.get(ORDERS_ENDPOINT + USER_ORDERS_ENDPOINT, {
    headers: { "Content-Type": "application/json" }
  });
}
